<div class="container mx-auto p-6">
  <h2 class="text-3xl font-semibold text-center mb-6">Registrar Evaluación</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="onBack()"
    >
      Volver
    </button>
  </div>
  <form
    *ngIf="mostrarEvaluacion"
    [formGroup]="evaluationForm"
    (ngSubmit)="onSubmit()"
    novalidate
    class="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
  >
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <!-- Nombre -->
      <div>
        <label for="nombre" class="block text-sm font-medium text-gray-700 mb-1"
          >Nombre</label
        >
        <input
          id="nombre"
          type="text"
          formControlName="nombre"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
          placeholder="Ingrese el nombre"
          maxlength="100"
        />
        <small
          *ngIf="
            evaluationForm.get('nombre')?.touched &&
            evaluationForm.get('nombre')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Nombre es obligatorio (máx. 100 caracteres)
        </small>
      </div>
      <!-- Área -->
      <div>
        <label
          for="id_area"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Área</label
        >
        <select
          id="id_area"
          formControlName="id_area"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione un área...
          </option>
          <option *ngFor="let area of areas" [value]="area.id_area">
            {{ area.nombre }}
          </option>
        </select>
        <small
          *ngIf="
            evaluationForm.get('id_area')?.touched &&
            evaluationForm.get('id_area')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Área es obligatoria.
        </small>
        <!-- Mensaje informativo cuando el rol es 3 -->
        <div *ngIf="id_rol === '3'" class="mt-2 text-gray-600">
          El área ha sido asignada automáticamente según su perfil
        </div>
      </div>
      <!--Etapa-->
      <div>
        <label for="etapa" class="block text-sm font-medium text-gray-700 mb-1"
          >Etapa</label
        >
        <select
          id="etapa"
          formControlName="etapa"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
        >
          <option value="" disabled selected>Seleccione un etapa...</option>
          <option value="Diagnostico">Diagnostico</option>
          <option value="Proceso">Proceso</option>
          <option value="Final">Final</option>
        </select>
        <small
          *ngIf="
            evaluationForm.get('etapa')?.touched &&
            evaluationForm.get('etapa')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Etapa es obligatoria.
        </small>
      </div>
      <!-- Nivel Educativo -->
      <div>
        <label
          for="nivel_educativo"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          Nivel Educativo
        </label>
        <select
          id="nivel_educativo"
          formControlName="nivel_educativo"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
          (change)="actualizarGrados()"
        >
          <option value="" disabled selected>Seleccione un nivel...</option>
          <option value="PRIMARIA">Primaria</option>
          <option value="SECUNDARIA">Secundaria</option>
        </select>
        <small
          *ngIf="
            evaluationForm.get('nivel_educativo')?.touched &&
            evaluationForm.get('nivel_educativo')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Nivel Educativo es obligatorio.
        </small>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
      <div>
        <label for="grado" class="block text-sm font-medium text-gray-700 mb-1">
          Grado
        </label>
        <select
          id="grado"
          formControlName="grado"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione un grado...
          </option>
          <option *ngFor="let grado of gradosDisponibles" [value]="grado">
            {{ grado }}
          </option>
        </select>
        <small
          *ngIf="
            evaluationForm.get('grado')?.touched &&
            evaluationForm.get('grado')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Grado es obligatorio.
        </small>
      </div>
      <!-- Cantidad de Preguntas -->
      <div>
        <label
          for="cantidad_preguntas"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          Cantidad de Preguntas
        </label>
        <input
          id="cantidad_preguntas"
          type="number"
          formControlName="cantidad_preguntas"
          (change)="actualizarNumeroPreguntas()"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
          min="5"
          max="30"
          placeholder="Ej. 20"
          [value]="numPreguntas"
        />
        <small
          *ngIf="
            evaluationForm.get('cantidad_preguntas')?.touched &&
            evaluationForm.get('cantidad_preguntas')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Debe ser entre 5 y 30 preguntas
        </small>
      </div>
      <!-- Duración -->
      <div>
        <label
          for="duracion"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Duración(min)</label
        >
        <input
          id="duracion"
          formControlName="duracion"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
          type="number"
          min="1"
          placeholder="Ingrese una duración"
          placeholder="Ej. 45"
        />
        <small
          *ngIf="
            evaluationForm.get('duracion')?.touched &&
            evaluationForm.get('duracion')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Duración es obligatoria.
        </small>
      </div>

      <!-- Fecha de Inicio -->
      <div>
        <label
          for="fecha_inicio"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Fecha de Inicio</label
        >
        <input
          id="fecha_inicio"
          formControlName="fecha_inicio"
          type="date"
          [min]="hoy"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
        />
        <small
          *ngIf="
            evaluationForm.get('fecha_inicio')?.touched &&
            evaluationForm.get('fecha_inicio')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Fecha de fin es obligatoria.
        </small>
      </div>
      <!-- Fecha de Fin -->
      <div>
        <label
          for="fecha_fin"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Fecha de Fin</label
        >
        <input
          id="fecha_fin"
          formControlName="fecha_fin"
          type="date"
          [min]="hoy"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
        />
        <small
          *ngIf="
            evaluationForm.get('fecha_fin')?.touched &&
            evaluationForm.get('fecha_fin')?.invalid
          "
          class="text-red-500 text-xs"
        >
          Fecha de fin es obligatoria.
        </small>
      </div>
    </div>
    <!-- Preguntas -->
    <div class="mb-6">
      <h3 class="text-lg font-medium text-gray-900 mb-3">
        Preguntas de Evaluación
      </h3>
      <div
        class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-4"
      >
        <div
          *ngFor="let control of preguntasArray.controls; let i = index"
          class="bg-gray-50 p-3 rounded-lg"
        >
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Pregunta {{ i + 1 }}
          </label>

          <!-- Opciones como radio buttons -->
          <div class="space-y-2">
            <label
              *ngFor="let option of ['A', 'B', 'C', 'D']; let j = index"
              class="flex items-center"
            >
              <input
                type="radio"
                [formControl]="getPreguntaControl(i)"
                [value]="option"
                name="pregunta{{ i }}"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span class="ml-2 text-sm text-gray-700">{{ option }}</span>
            </label>
          </div>

          <!-- Mensaje de validación -->
          <small
            *ngIf="
              getPreguntaControl(i).touched && !getPreguntaControl(i).valid
            "
            class="text-red-500 text-xs"
          >
            Seleccione una respuesta.
          </small>
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end">
      <button
        type="submit"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Guardar Evaluación
      </button>
    </div>
  </form>

  <form
    *ngIf="mostrarInputImagenes"
    class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-6"
  >
    <!-- Título principal -->
    <h2
      class="text-xl md:text-2xl font-semibold text-gray-800 mb-6 text-center"
    >
      Subir Imágenes de la Evaluación
    </h2>
    <!-- Instrucciones paso a paso -->
    <div class="space-y-6 mb-6">
      <div class="bg-gray-50 p-4 rounded-lg">
        <h3 class="text-xl font-semibold mb-2">
          Paso 1: Convertir PDF a Imágenes
        </h3>
        <p class="text-gray-600">
          Primero, convierta su evaluación de PDF a imágenes usando el siguiente
          servicio:
        </p>
        <button
          type="button"
          class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mt-2"
          (click)="abrirConvertidorPdf()"
        >
          Ir a Convertidor PDF
        </button>
      </div>

      <div class="bg-gray-50 p-4 rounded-lg">
        <h3 class="text-xl font-semibold mb-2">
          Paso 2: Preparar las Imágenes
        </h3>
        <p class="text-gray-600">Antes de subir las imágenes, asegúrese de:</p>
        <ul class="list-disc pl-5 mb-4">
          <li>Comprimir las imágenes para optimizar el tamaño</li>
          <li>
            Renombrar las imágenes en orden ascendente (1.jpg, 2.jpg, etc.)
          </li>
          <li>Verificar que todas las imágenes son legibles</li>
        </ul>
      </div>

      <div class="bg-gray-50 p-4 rounded-lg">
        <h3 class="text-xl font-semibold mb-2">Paso 3: Subir las Imágenes</h3>
        <div>
          <label for="imagenes" class="block font-semibold mb-1"
            >Imágenes</label
          >

          <!-- Input para múltiples archivos -->
          <input
            type="file"
            multiple
            accept="image/*"
            (change)="handleFileInput($event)"
            [disabled]="filesToUpload.length >= maxFiles"
            class="border border-gray-300 rounded w-full py-2 px-4 mb-2"
          />

          <!-- Mensaje de límite -->
          <small class="text-gray-500">
            Debe subir entre {{ minFiles }} y {{ maxFiles }} imágenes
          </small>

          <p class="text-gray-600 mt-2">
            Las imágenes se subirán en el orden numérico de sus nombres (1.jpg,
            2.jpg, etc.)
          </p>
        </div>
      </div>
    </div>
  </form>
</div>
